import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { DeleteConnectorsRequest } from '@/entities/connector/types';

export const deleteConnectorsApi = async (request: DeleteConnectorsRequest) => {
  await connectorApiClient.delete('/connectors', { data: request });
};
